"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var observable_1 = require("../player/observable");
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Connected"] = 0] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 1] = "Disconnected";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
var NetworkStatus = (function () {
    function NetworkStatus() {
        this.statusObservable = new observable_1.Observable();
    }
    NetworkStatus.prototype.onChange = function (handler) {
        this.statusObservable.registerObserver(handler, this);
    };
    NetworkStatus.prototype.notifyStatusChange = function (status) {
        this.statusObservable.notifyObservers(status);
    };
    return NetworkStatus;
}());
exports.NetworkStatus = NetworkStatus;
